import apolloClient from '../../lib/apolloClient'
import { GET_PAGE_LINKS_QUERY } from '../queries'
import { GetPageLinksQuery, GetPageLinksQueryVariables } from '../__generated__/types'
import { localeToMarketCode } from '../../utils'
import { PageProps } from '../../types'

export const fetchPageLinks = async (locale: string): Promise<PageProps['pageLinks']> => {
  const market = localeToMarketCode(locale)
  const filter = {
    code: {
      _eq: market,
    },
  }
  const translations_filter = { languages_code: { _eq: locale } }
  const {
    data: { markets },
  } = await apolloClient.query<GetPageLinksQuery, GetPageLinksQueryVariables>({
    query: GET_PAGE_LINKS_QUERY,
    variables: {
      filter,
      translations_filter,
    },
  })
  return markets[0]?.pages?.map(({ pages_id }) => pages_id) ?? []
}
